import Nullstack from 'nullstack';
export default function IconMedicineSyrup({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-medicine-syrup",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 21h8a1 1 0 0 0 1 -1v-10a3 3 0 0 0 -3 -3h-4a3 3 0 0 0 -3 3v10a1 1 0 0 0 1 1z"
  }), "   ", Nullstack.element("path", {
    d: "M10 14h4"
  }), "   ", Nullstack.element("path", {
    d: "M12 12v4"
  }), "   ", Nullstack.element("path", {
    d: "M10 7v-3a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3"
  }), " ");
}